"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constant = require("../../constant");

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Redirect = {
  cashier: [{
    pattern: {
      "IOS|FINO": ["gte", "1.0.0"],
      "ANDROID|FINO": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(130, option);
    }
  }],
  "webview-close": [{
    pattern: {
      "IOS|FINO": ["gte", "1.0.0"],
      "ANDROID|FINO": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(131);
    }
  }]
};

exports.default = Redirect;